// Botón flotante (FAB) del copiloto Jido — jido-agent F2.
//
// GATING (spec jido-chat-widget "Role- and flag-gated visibility"): visible
// SOLO para directivo/coordinador/super_admin CON `ctx.puede_usar_copiloto
// === true`. El gate duro real vive en el backend
// (requireRole en POST /api/jido/chat) — este gate es solo de UI.
//
// Se monta GLOBALMENTE en el router (junto al Toaster), no por layout de rol,
// para cubrir los tres roles habilitados con un solo punto de montaje.

import { useState } from 'react';
import type { Role } from 'schemas';
import { useAuth } from '../../lib/auth/useAuth';
import { useMe } from '../../lib/api/queries';
import { Button } from '../../components/ui/button';
import { Icon } from '../../components/ui/icon';
import { CopilotoDrawer } from './CopilotoDrawer';

const ROLES_CON_COPILOTO: Role[] = ['directivo', 'coordinador', 'super_admin'];

export function CopilotoFab() {
  const [open, setOpen] = useState(false);
  const { state } = useAuth();

  const rol = state.kind === 'signed_in' ? state.claims.rol : null;
  const rolElegible = rol !== null && ROLES_CON_COPILOTO.includes(rol);

  // Solo dispara GET /api/me cuando el rol ya calificó — evita el fetch
  // (y el 401 transitorio) para roles que nunca van a ver el widget.
  const me = useMe({ enabled: rolElegible });

  const visible = rolElegible && me.data?.ctx.puede_usar_copiloto === true;

  if (!visible) return null;

  return (
    <>
      <Button
        variant="primary"
        size="icon"
        onClick={() => setOpen(true)}
        aria-label="Abrir copiloto Jido"
        className="fixed bottom-6 right-6 z-50 h-12 w-12 rounded-full shadow-elevated"
      >
        <Icon name="message-circle" size={22} />
      </Button>
      <CopilotoDrawer open={open} onClose={() => setOpen(false)} />
    </>
  );
}
